import { LicenseInfo } from "@mui/x-license";

export const VERSION = import.meta.env.VITE_RELEASE;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
export const azureTenantId = import.meta.env.VITE_AZURE_TENANT_ID;
export const meticulousProjectId = import.meta.env.VITE_METICULOUS_PROJECT_ID;
export const sentryReplaySessionSampleRate = parseFloat(
  import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE
);
export const sentryReplayErrorSampleRate = parseFloat(
  import.meta.env.VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE
);
const parseSampleRate = (value: string | undefined, fallback: number) => {
  const rate = parseFloat(value ?? "");
  return Number.isFinite(rate) && rate >= 0 && rate <= 1 ? rate : fallback;
};
export const sentryStandaloneRequestSampleRate = parseSampleRate(
  import.meta.env.VITE_SENTRY_STANDALONE_REQUEST_SAMPLE_RATE,
  0.001
);
export const sentryVideoPlaybackSampleRate = parseSampleRate(
  import.meta.env.VITE_SENTRY_VIDEO_PLAYBACK_SAMPLE_RATE,
  1
);
export const VIDEO_PLAYBACK_SPAN_OP = "ui.video.playback";
export const MAX_REVISION_HISTORY_LENGTH = 100;

export const languages: Record<string, string> = {
  "en-GB": "English (UK)",
  "en-US": "English (US)",
  "de-DE": "Deutsch",
  "pl-PL": "Polski",
  "es-AR": "Español",
  "fr-FR": "Français",
};

export const defaultLanguage = "en-GB";

export const materialGroupColours: Record<string, string> = {
  // `snake_case` is used to match the data returned by the python backend
  heavy_scrap: "#d7301f",
  heavy_small_scrap: "#fdcc8a",
  light_scrap: "#0570b0",
  "light_scrap/light_small_scrap": "#74a9cf",
  light_small_scrap: "#bdc9e1",
  dri: "#36454F",
};

// Configure authentication via Firebase
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
};

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENCE);

export const recipeDecimalPlaces = 1;
